<template>
  <USelectMenu
    v-model="_value"
    :items="orders"
    label-key="orderNumber"
    by="idOrder"
    :placeholder="$t('components.order.elements.select.title')"
    :filter-fields="['orderNumber']"
  >
    <template #default="{ modelValue: selected }">
      <div v-if="selected" class="flex items-center">
        <p class="block opacity-90 line-clamp-1">
          {{ selected.orderNumber }} ({{ selected.dateLabel }} - {{ selected.priceLabel }})
        </p>
      </div>
    </template>

    <template #item="{ item }">
      <div v-if="item" class="flex items-center">
        <div>
          <p class="text-sm opacity-90 line-clamp-1">
            {{ item.orderNumber }}
          </p>
          <p class="text-sm opacity-70 line-clamp-1">
            {{ item.dateLabel }} - {{ item.priceLabel }}
          </p>
        </div>
      </div>
    </template>
  </USelectMenu>
</template>

<script setup lang="ts">
const { $notification, $api } = useNuxtApp()

interface Props {
  modelValue?: any
  customer?: any
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
  customer: null,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: any): void
}>()

const orders = ref<any[]>([])

const _value = computed({
  get: () => props.modelValue,
  set: (value: any) => emit('update:modelValue', value),
})

async function fetchOrders() {
  try {
    const idCustomer = props.customer?.idCustomer || props.customer?.id
    const response = idCustomer ? await $api.customer.orders(String(idCustomer), { page: 1 }) : null

    if (response?.items) {
      orders.value = response.items
    }
  } catch (e: any) {
    console.log(e)
    $notification.error({ errors: e.errors })
  }
}

onMounted(() => {
  fetchOrders()
})
</script>
